<script>
  import options from './FormInputRadio.options'
  const componentOptions = options
  export default componentOptions
</script>

<template>

  <div class="be-form__input-wrapper be-form__input-radio" 
          :class="{ValidationRequired: isRequired, 
            'validation-error' :isValidationError, 
            'disabled' :disabled }">

        <fieldset  class="be-form__input-radio-fieldset">
            <legend v-if="legend" class="be-form__input-radio-legend">
              {{ legend }}
              {{ isRequired ? ' *' : ''}}
            </legend>

            <template v-for="(option, index) in radioOptions" :key="index">
              <div class="be-form__input-radio-input-wrapper">
                <input
                  class="be-form__input-radio-input"
                  type="radio"
                  :name="inputName"
                  :value="option.value"
                  v-model="localValue"
                  :aria-describedby="`${inputName}__desc`"
                  :id="`${inputName}-${index}`"
                />
                <label :for="`${inputName}-${index}`" class="be-form__input-radio-label">
                  {{ option.label }}
                </label>
              </div>
            </template>
          </fieldset>
      

          <div aria-live="assertive">
              <p class="be-form__input-validation-error" role="alert" v-if="isValidationError && !disabled">
                  {{ errorMessageLabel }}
              </p>
          </div>

          <div aria-live="polite">
              <p class="be-form__input-helptext" :id="`${inputName}__desc`" v-if="helpMessageLabel && (!isValidationError && !disabled)" >
                  {{ helpMessageLabel }}
              </p>
          </div>

    </div>

</template>
